import React from 'react';
import { Box, HStack, Text } from '@chakra-ui/layout';
import { Tooltip } from '@chakra-ui/tooltip';
import {
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Flex,
} from '@chakra-ui/react';
import { IconBaseProps } from 'react-icons';
import { useHistory } from 'react-router';

type MenuItem = {
  label: string;
  to?: string;
  toExternal?: string;
};

interface IProps {
  label: string;
  activated: boolean;
  handleActiveSideBar(): void;
  icon: React.ComponentType<IconBaseProps>;
  items: MenuItem[];
}

const Menu: React.FC<IProps> = ({
  label,
  activated,
  icon: Icon,
  items,
  handleActiveSideBar,
}) => {
  const history = useHistory();
  return (
    <Tooltip hasArrow label={label} isDisabled={activated} placement="right">
      <AccordionItem border="none">
        {({ isExpanded }) => (
          <>
            <AccordionButton
              height="70px"
              background="green.500"
              color="white"
              px={`${activated ? '18px' : '16px'}`}
              _focus={{ boxShadow: 'none' }}
              _hover={{ background: 'white', color: 'black' }}
              _expanded={
                activated
                  ? { background: 'white', color: 'black' }
                  : { background: 'green' }
              }
              onClick={() => {
                if (!activated) {
                  handleActiveSideBar();
                }
              }}
            >
              <Box flex="1" textAlign="left">
                <HStack>
                  <Icon size={25} />
                  {activated && <Text>{label.toUpperCase()}</Text>}
                </HStack>
              </Box>
              {activated && <AccordionIcon />}
            </AccordionButton>

            <AccordionPanel
              pb={0}
              p={0}
              style={
                !activated || !isExpanded
                  ? {
                      overflow: 'hidden',
                      display: 'none',
                      opacity: 0,
                      height: '0px',
                    }
                  : {}
              }
            >
              {items.map((item) => (
                <>
                  <Flex
                    align="center"
                    key={item.label}
                    background="gray.50"
                    cursor="pointer"
                    _hover={{ background: 'gray.100', color: 'black' }}
                    transition="all 0.3s"
                    color="black"
                    height="50px"
                    w="100%"
                    px={`${activated ? '16px' : '12px'}`}
                    onClick={() =>
                      item.toExternal
                        ? window.open(item.toExternal, '_blank')
                        : history.push(`${item.to}`)
                    }
                  >
                    <Text fontSize="sm">{item.label.toUpperCase()}</Text>
                  </Flex>
                </>
              ))}
            </AccordionPanel>
          </>
        )}
      </AccordionItem>
    </Tooltip>
  );
};

export default Menu;
